'use strict';

import {
    appendXSelectedCompanyHeader,
    companyGuard, dropzoneExists, fnErrorMsg, getSelectedCompany,
    handleErrors, populateSelect, popupCenterDual, reloadVouchersTableWithMissingVoucherText,
    toggleSpinnerByParent
} from "../jquery-functions-library";
import {element_exists} from "../functions";
import * as Dropzone from "dropzone";


export var fnUploadBankStatement = function () {

        if (!element_exists('#form-upload-statement')) return false;

        var form = $('#form-upload-statement');
        var uploadUrl = '/voucher/statement/upload';
        /*var dataTable = $('#datatable-vouchers').DataTable();*/
        var modal = $('#modal-upload-statement');

        if (!dropzoneExists('#dropzone-upload-statement')) {

            Dropzone.autoDiscover = false;

            var langDropzone = allLangFiles.dropzone;

            const MAX_FILES_ALLOWED = 4;
            const MAX_FILE_SIZE = 9;

            $('#dropzone-upload-statement').dropzone({

                dictDefaultMessage: langDropzone.dictCustomDropMessage,
                dictFallbackMessage: langDropzone.dictFallbackMessage,
                dictFallbackText: langDropzone.dictFallbackText,
                dictFileTooBig: langDropzone.dictFileTooBig,
                dictInvalidFileType: langDropzone.dictInvalidFileType,
                dictResponseError: langDropzone.dictResponseError,
                dictCancelUpload: langDropzone.dictCancelUpload,
                dictCancelUploadConfirmation: langDropzone.dictCancelUploadConfirmation,
                dictRemoveFile: langDropzone.dictRemoveFile,
                dictMaxFilesExceeded: langDropzone.dictMaxFilesExceeded,

                url: uploadUrl,
                addRemoveLinks: true,
                autoDiscover: false,
                uploadMultiple: true,
                parallelUploads: MAX_FILES_ALLOWED,
                maxFiles: MAX_FILES_ALLOWED,
                maxFilesize: MAX_FILE_SIZE,
                acceptedFiles: 'application/pdf',
                // autoProcessQueue: false, // this is important as you dont want form to be submitted unless you have clicked the submit button

                sendingmultiple: function (file, xhr, formData) {
                    // Passing formvalues associated to dropzone
                    $.each(form.serializeArray(), function (k, v) {
                        formData.append(v.name, v.value);
                    });
                    console.log(this.getSelectedAccount());
                    if (this.getSelectedAccount().voucher_statement_id) {
                        formData.append('voucher_statement_id', this.getSelectedAccount().voucher_statement_id)
                    }
                    appendXSelectedCompanyHeader(xhr);
                },

                init: function () {

                    /*Only use this on methods. Can cause errors if using this inside a method (e.g. button-clicks...)*/
                    var dz = this;

                    dz.cleaningUp = false;

                    dz.accounts = {};

                    dz.selAcc = 0;

                    /*Custom methods */
                    this.cleanUp = function (softDelete) {

                        console.log('cleaning up');

                        $.each(dz.accounts, function (k, v) {
                            if (!v.registerCompleted)
                                v.softDelete = softDelete;
                        });

                        console.log(softDelete);

                        dz.cleaningUp = !softDelete;
                        dz.removeAllFiles();
                        dz.cleaningUp = false;
                    };

                    this.getAccounts = function () {
                        return dz.accounts;
                    }

                    this.setAccounts = function (accounts) {

                        var firstElement = true;

                        $.each(accounts, function (k, v) {
                            v.registerCompleted = false;
                            v.softDelete = false;
                            dz.accounts[v.ContraAccountHandle_Number] = v;

                            if (firstElement) {
                                dz.setSelectedAccount(v.ContraAccountHandle_Number);
                                firstElement = false;
                            }
                        });

                        console.log(dz.accounts);
                        console.log(dz.getSelectedAccount());
                    };

                    /**
                     * If there are files in the dropzone, return true to handle warnings for users
                     * @returns {boolean}
                     */
                    this.isProcessing = function () {

                        var processing = false;

                        $.each(dz.accounts, function (k, v) {

                            console.log((v.mockFiles));
                            console.log((dz.files));

                            if (
                                (!v.registerCompleted && dz.files.length > 0 && v.mockFiles !== undefined && v.mockFiles.length > 0)
                                || (!v.registerCompleted && v.mockFiles !== undefined && v.mockFiles.length > 0)
                            ) {

                                processing = true;
                                return true;
                            }

                        });

                        return processing;
                    };

                    this.createMockfiles = function () {

                        var mockFiles = dz.getSelectedAccount().mockFiles;

                        if (mockFiles !== undefined && mockFiles.length > 0) {

                            if (mockFiles.length >= MAX_FILES_ALLOWED) {
                                dz.removeEventListeners();
                            }

                            for (let i = 0; i < mockFiles.length; i++) {
                                let mockFile = mockFiles[i];
                                dz.emit("addedfile", mockFile);

                                // Make sure that there is no progress bar, etc...
                                dz.emit("complete", mockFile);

                                dz.emit("thumbnail", mockFile, "/img/pdf.png");
                            }
                            dz.files = mockFiles;

                            if (dz.getSelectedAccount().registerCompleted) {

                                displayState();
                            } else {
                                registerState();
                            }
                        } else {
                            console.log('wrong uploadstate');
                            uploadState();
                        }
                    };

                    this.setSelectedAccount = function (selectedAccount) {

                        dz.selAcc = selectedAccount;
                        dz.getSelectedAccount().softDelete = false;
                        console.log(dz.getSelectedAccount());
                    };

                    this.setRegisterCompleted = function (registerCompleted) {
                        dz.getSelectedAccount().registerCompleted = registerCompleted;

                    };

                    this.getSelectedAccount = function () {

                        return dz.accounts[dz.selAcc];
                    };
                    /*End custom methods*/

                    /*Standard methods*/
                    this.on('maxfilesreached', function () {
                        dz.removeEventListeners();

                        console.log('maxfilesreached');
                    });

                    this.on('addedfile', function (file) {
                        dz.emit("thumbnail", file, "/img/pdf.png");
                    });

                    this.on("processing", function () {

                        console.log(this);
                        console.log('processing');

                    });

                    this.on('success', function (file, response) {

                        console.log(file);
                        console.log(response);
                        console.log('success');

                        let selectedAccount = dz.getSelectedAccount();

                        if (selectedAccount.mockFiles === undefined) {
                            selectedAccount.mockFiles = [];
                        }
                        for (let i = 0; i < response.files.data.length; i++) {
                            let current = response.files.data[i];
                            if (current.original_filename == file.name) {
                                selectedAccount.mockFiles.push({
                                    storage_file_id: current.storage_file_id,
                                    name: current.original_filename,
                                    url: current.url,
                                    size: file.size,
                                    status: file.status,
                                });
                                $(file.previewElement).off("click").on("click", function (e) {
                                    popupCenterDual(current.url, current.original_filename, window.innerWidth / 3, window.innerHeight / 1.5);
                                });
                                break;
                            }
                        }
                        selectedAccount.voucher_statement_id = response.files.voucher_statement_id;

                        console.log(selectedAccount);

                        $('.dz-complete').addClass('.dz-success');
                        $('#contra_account').prop('disabled', false);

                        registerState();
                    });

                    this.on("queuecomplete", function (file) {
                        console.log('queuecomplete');
                        console.log(dz);
                    });

                    this.on("thumbnail", function (file) {
                        console.log('thumbnail');
                        console.log(file);
                        let filename = file.name;
                        let url = file.url;

                        $(file.previewElement).off("click").on("click", function (e) {
                            popupCenterDual(url, filename, window.innerWidth / 3, window.innerHeight / 1.5);
                        });
                    });

                    this.on("removedfile", function (file) {

                        // console.log('removedfile');
                        // console.log(!dz.cleaningUp);
                        // console.log(file);

                        dz.setupEventListeners();

                        if (!dz.cleaningUp) {

                            const accounts = $('#dropzone-upload-statement')[0].dropzone.getAccounts();

                            for (let key in accounts) {
                                if (accounts.hasOwnProperty(key)) {
                                    let account = accounts[key];
                                    account.shouldDeleteStatement = false;
                                }
                            }

                            let currentFiles = dz.getSelectedAccount().mockFiles;

                            for (let i = 0; i < currentFiles.length; i++) {

                                currentFiles[i].shouldDelete = false;

                                if (file.name === currentFiles[i].name) {
                                    currentFiles[i].shouldDelete = !dz.getSelectedAccount().softDelete;
                                }
                            }
                            let data = JSON.parse(JSON.stringify(dz.accounts));

                            $.ajax({
                                type: 'POST',
                                url: '/voucher/statement/delete',
                                data: data,
                                success: function (response) {

                                    $.each(response.deletedFiles, function (k, v) {
                                            if (dz.accounts[k]) {
                                                uploadState();

                                                for (let i = 0; i < dz.accounts[k].mockFiles.length; i++) {
                                                    let current = dz.accounts[k].mockFiles[i];
                                                    console.log(v);
                                                    for (let j = 0; j < v.length; j++) {

                                                        if (current.storage_file_id == v[j]) {
                                                            dz.accounts[k].mockFiles.splice(i, 1);
                                                        }
                                                    }
                                                }

                                                dz.accounts[k].registerCompleted = false;
                                                dz.accounts[k].softDelete = false;
                                                dz.accounts[k].shouldDeleteStatement = false;
                                            }
                                        }
                                    );
                                    let selectedAccount = dz.getSelectedAccount();
                                    if (selectedAccount.mockFiles && selectedAccount.mockFiles.length > 0) {
                                        registerState();
                                    }
                                },
                                error: fnErrorMsg
                            });
                        }

                    });
                    /*End standard methods*/
                }
            });
        }

        var langVouchers = allLangFiles.vouchers.js;


        $('#btn-open-statement-upload').off('click').on('click', function (e) {

            e.preventDefault();

            var company_id = getSelectedCompany();

            if (!companyGuard()) {
                $.ajax({
                    method: 'GET',
                    url: '/voucher/statement/accounts/' + company_id,
                    success: function (response) {

                        form.find('input[name="company_id"]').attr('value', company_id);
                        populateSelect(response.accounts, $('#contra_account'), ['ContraAccountHandle_Number', 'name'], 'ContraAccountHandle_Number', langVouchers.account_select);

                        if (response.accounts.length > 0) {
                            $('#dropzone-upload-statement')[0].dropzone.setAccounts(response.accounts);
                            $('#dropzone-upload-statement')[0].dropzone.cleanUp(false);
                            uploadState();
                            modal.modal('show');
                        } else {
                            toastr.info(langVouchers.input_valid)
                        }
                    },
                    error: fnErrorMsg
                });
            } else {
                toastr.error(langVouchers.company_id);
            }
        });

        modal.off("hide.bs.modal").on("hide.bs.modal", function (e) {

            if (modal.attr('data-close') === 'false') {

                var isProcessing = $('#dropzone-upload-statement')[0].dropzone.isProcessing();

                if (isProcessing) {

                    e.preventDefault();

                    $.confirm({
                        title: langVouchers.uploads_processing_title,
                        content: langVouchers.uploads_processing_content,
                        theme: 'supervan',
                        columnClass: 'col-md-12',
                        backgroundDismiss: true,
                        buttons: {
                            Ja: {
                                action: function () {

                                    modal.attr('data-close', true);
                                    $('#dropzone-upload-statement')[0].dropzone.cleanUp(false);
                                    modal.modal('hide');

                                    const accounts = $('#dropzone-upload-statement')[0].dropzone.getAccounts();

                                    for (let key in accounts) {
                                        if (accounts.hasOwnProperty(key)) {
                                            let account = accounts[key];
                                            account.shouldDeleteStatement = true;

                                            if (account.mockFiles === undefined) continue;

                                            for (let i = 0; i < account.mockFiles.length; i++) {
                                                account.mockFiles[i].shouldDelete = true;
                                            }
                                        }
                                    }
                                    $.ajax({
                                        type: 'POST',
                                        url: '/voucher/statement/delete',
                                        data: JSON.parse(JSON.stringify(accounts)),
                                        success: function (response) {
                                            // console.log(response);
                                        },
                                        error: fnErrorMsg
                                    });
                                },
                                text: langVouchers.yes,
                            },
                            Nej: {
                                action: function () {
                                    modal.attr('data-close', false);
                                },
                                text: langVouchers.no
                            }
                        },
                    });
                }
            } else {
                modal.attr('data-close', false);
            }
            reloadVouchersTableWithMissingVoucherText();
        });

        $('#btn-register-economic').off('click').on('click', function (e) {

            e.preventDefault();

            console.log('here');

            registerToEconomic();
        });

        $('#contra_account').off('change').on('change', function (e) {
            e.preventDefault();

            var selectedAccount = $(this).val();
            $('#dropzone-upload-statement')[0].dropzone.cleanUp(true);
            $('#dropzone-upload-statement')[0].dropzone.setSelectedAccount(selectedAccount);
            $('#dropzone-upload-statement')[0].dropzone.createMockfiles();
        });

        /*Default state*/
        uploadState();

        function uploadState() {
            hideAll();
            $('#btn-upload-statement').fadeIn();
        }

        function registerState() {
            hideAll();
            $('#btn-display-statement').fadeIn();
            $('#btn-register-economic').fadeIn();
        }

        function displayState() {
            form.find('.dz-remove').hide();
            hideAll();
            $('#btn-display-statement').fadeIn();
        }

        function hideAll() {
            $('#btn-upload-statement').hide();
            $('#btn-display-statement').hide();
            $('#btn-register-economic').hide();
        }

        function registerToEconomic() {
            var company_id = form.find('input[name="company_id"]').attr('value');
            // var filename = $('#dropzone-upload-statement')[0].dropzone.getPathToFile();//TODO not gonna work...
            var fileInformation = $('#dropzone-upload-statement')[0].dropzone.getSelectedAccount();
            console.log(fileInformation);

            var data = {
                fileInformation: JSON.parse(JSON.stringify(fileInformation)),
                company_id: company_id,
            };
            toggleSpinnerByParent(modal, $('#btn-register-economic'));
            $.ajax({
                method: 'POST',
                url: '/voucher/statement/register',
                data: data,
                success: function (response) {

                    if (response.errorMessages) {
                        handleErrors(response);
                    } else {
                        $('#dropzone-upload-statement')[0].dropzone.setRegisterCompleted(true);
                        displayState();
                    }
                    toggleSpinnerByParent(modal, $('#btn-register-economic'));
                },
                error: fnErrorMsg
            });
        }
    }
;